import { ReactElement, useEffect } from 'react';

import { useAnalytics } from 'hooks/useAnalytics';
import { useConversation } from 'hooks/conversation';
import { useView } from 'hooks/view';

import { ACTIONS } from 'constants/hook';
import { ConversationStateType } from 'hooks/conversation/types';

import { Button } from 'components/Input/Button';
import Typography from 'components/Typography/Typography';

import { DataDogLogger } from 'utils/dataDog';
import { CUSTOM_ACTION_NAMES } from 'utils/dataDog/constants';

import { ANALYTICS } from 'analytics/constants';
import { AnalyticReconnectedDetailsType } from 'analytics/types';
import { reconnect, refreshButton } from './content';
import { StyledAlertIcon, StyledReconnectWrapper } from './styles';
import { htmlId } from 'utils/html';

const Reconnect = (): ReactElement => {
  const { trackEvent } = useAnalytics();
  const { viewState, dispatchViewAction } = useView();
  const { dispatchConversationAction, conversationState: state } = useConversation();

  useEffect(() => {
    const nextViewState = { ...viewState };
    nextViewState.scrollToBottom.isCTAVisible = false;
    nextViewState.scrollToBottom.isAutoScrollNextMsg = false;
    dispatchViewAction({ type: ACTIONS.CHANGE, payload: nextViewState });
  }, []);

  const onClickRefreshChat = () => {
    window.CarvanaChatUi.startInactivityCounter();
    const context = { method: 'Reconnect CTA button' };
    DataDogLogger.action(CUSTOM_ACTION_NAMES.INACTIVITY_RECONNECT, context);
    trackEvent({
      analyticEvent: ANALYTICS.EVENT.CHAT_RECONNECTED,
      details: { reconnect_method: context.method } as AnalyticReconnectedDetailsType,
    });

    const nextState: ConversationStateType = {
      ...state,
      isConnected: false,
      isInitializationRequested: true,
      isAnimateLastMessage: false,
    };

    dispatchConversationAction({
      type: ACTIONS.CHANGE,
      payload: nextState,
    });
  };

  return (
    <StyledReconnectWrapper id={htmlId('chat-reconnect-wrapper')}>
      <StyledAlertIcon />
      <Typography variant='label' size='lg' fontWeight={500}>
        {reconnect}
      </Typography>
      <Button onClick={onClickRefreshChat}>{refreshButton}</Button>
    </StyledReconnectWrapper>
  );
};

export default Reconnect;
